import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8.474 6.411c.174-.001.39-.002.603.51l.329.798a66.8 66.8 0 0 0 .587 1.408c.075.148.124.322.025.52l-.042.084a1.69 1.69 0 0 1-.255.412c-.05.058-.101.12-.152.183-.103.124-.205.249-.294.338-.149.148-.304.309-.13.606.173.298.77 1.27 1.653 2.059a7.67 7.67 0 0 0 2.194 1.386c.082.036.148.064.197.089.297.148.47.123.644-.075.173-.198.743-.867.94-1.165.199-.297.397-.248.67-.149.272.1 1.733.818 2.03.967l.163.08c.208.1.348.168.407.267.075.124.075.72-.173 1.413-.248.694-1.435 1.328-2.006 1.413-.513.077-1.16.109-1.873-.117-.431-.137-.985-.32-1.694-.626-2.786-1.203-4.67-3.903-5.026-4.414l-.052-.073-.003-.004c-.157-.21-1.21-1.616-1.21-3.07 0-1.37.672-2.087.981-2.417l.059-.062c.272-.298.594-.372.792-.372a11.913 11.913 0 0 1 .636.011Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.741 17.837.054 24l6.306-1.654a11.89 11.89 0 0 0 5.685 1.448h.005c6.556 0 11.894-5.335 11.896-11.893a11.819 11.819 0 0 0-3.48-8.413A11.82 11.82 0 0 0 12.05 0C5.493 0 .156 5.335.153 11.892c0 2.096.547 4.142 1.588 5.945Zm5.272 2.57-.36-.214-3.743.982.999-3.648-.235-.374a9.86 9.86 0 0 1-1.512-5.26c.002-5.45 4.438-9.884 9.892-9.884a9.823 9.823 0 0 1 6.99 2.898 9.823 9.823 0 0 1 2.894 6.993c-.002 5.451-4.438 9.885-9.888 9.885h-.004a9.874 9.874 0 0 1-5.033-1.378Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionWhatsApp24 = createIcon(IconComponent);